// export const API_URL = "http://localhost:3001";
export const CREATE_JOB_EMAIL = "jobs@positionbuilding.com";

export const API_URL = "https://api.positionbuildingonline.com";
